<template>
  <div class="timeline">
    <div
      v-for="(item, i) in items"
      :key="i"
      class="timeline-item"
      :class="{ active: i === 0 }"
    >
      <div class="circle"></div>
      <div class="label font-Regular-16 onPrimary--text">
        <span>{{ item.label }}</span>
        <div class="mt-2 font-Light-14 gray2--text">
          <span class="ltr">
            {{ $t("common.Date") }}
            {{ item.date | formatDate }}</span
          >
          <!--          <span> {{ $t("common.Time") }} {{ item.date | formatDate }}</span>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";

export default {
  props: ["itemData"],
  data() {
    return {
      items: [
        {
          label: this.$t(
            "staking.stakingPlans.dialogDetail.planSchedule.Start_Of_Staking_Plan"
          ),
          date: this.itemData.subscriptionStartDate
        },
        {
          label: this.$t(
            "staking.stakingPlans.dialogDetail.planSchedule.Daily_Profit_Distribution_Date"
          ),
          date: this.itemData.profitDistributionDate
        },
        {
          label: this.$t(
            "staking.stakingPlans.dialogDetail.planSchedule.Plan_End_Date"
          ),
          date: this.itemData.subscriptionEndDate
        },
        {
          label: this.$t(
            "staking.stakingPlans.dialogDetail.planSchedule.Profit_Release_Date"
          ),
          date: this.itemData.profitReleaseDate
        },
        {
          label: this.$t(
            "staking.stakingPlans.dialogDetail.planSchedule.Asset_Release_Date"
          ),
          date: this.itemData.assetReleaseDate
        }
      ]
    };
  },
  methods: {
    formatTimes(time) {
      return dayjs(time).format("mm : HH");
    }
  }
  // methods: {
  //   formatTimes(time) {
  //     return dayjs(time).format("mm : HH");
  //   }
  // }
};
</script>

<style scoped>
.timeline {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  margin-top: 24px;
}

.timeline-item {
  position: relative;
  padding-bottom: 8px;
}

.ltr .timeline-item::before {
  left: 5.5px;
}

.timeline-item::before {
  content: "";
  position: absolute;
  right: 5.5px;
  top: 20px;
  width: 2px;
  height: 100%;
  background-color: #888;
  z-index: 0;
}

.timeline-item:last-child::before {
  display: none;
}

.timeline-item.active::before {
  background-color: #3f51b5;
}

.circle {
  width: 12px;
  height: 12px;
  background-color: #888;
  border-radius: 50%;
  position: absolute;
  top: 10px;
  z-index: 1;
}

.timeline-item.active .circle {
  background-color: #3f51b5;
}
.ltr .label {
  margin-left: 20px;
}
.label {
  margin-right: 20px;
  margin-top: 10px;
  justify-content: unset !important;
  display: block !important;
}
</style>
